import { Body, Box, Button, Heading } from '@hover/blueprint';
import { iX } from '@hover/icons';
import React, { useContext } from 'react';

import { SlideSmartMenu } from 'src/modules/designStudio/components/Toolbar/SlideSmartMenu';
import type { Menu } from 'src/modules/designStudio/constants';
import { historyContext } from 'src/modules/designStudio/providers';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { Page, buttonPressed } from 'src/shared/telemetry';

import { CardHeader } from '../CardHeader';

interface PropTypes {
  closeMenu: () => void;
  bodyText: string | undefined;
  headerText: string;
  menu: Menu | null;
  toolbarRef: React.RefObject<HTMLElement> | null;
}

const ResetCard = ({
  closeMenu,
  bodyText,
  headerText,
  menu,
  toolbarRef,
}: PropTypes) => {
  const t = useTranslate(TranslationNamespace.COMMON);
  const { resetDesign } = useContext(historyContext);

  const trackButtonPressed = (buttonText: string) => {
    const buttonPressedTrackingData = {
      button_text: buttonText,
      item_type: 'resetButton',
      page_or_screen_name: Page.DESIGN_STUDIO,
      primary_cta: false,
    };

    buttonPressed(buttonPressedTrackingData);
  };

  const onPressResetYes = () => {
    resetDesign();
    trackButtonPressed('yes');
    closeMenu();
  };
  const onPressResetNo = () => {
    trackButtonPressed('no');
    closeMenu();
  };

  return (
    <SlideSmartMenu
      backgroundColor="neutral.backgroundDark"
      closeMenu={closeMenu}
      containerRef={toolbarRef}
      menu={menu}
    >
      <CardHeader rightActionHandler={closeMenu} rightIcon={iX} />
      <Box alignSelf="center">
        <Heading marginBottom={0} size={400} textAlign="center">
          {headerText}
        </Heading>
      </Box>
      <Box alignSelf="center" marginBottom={200}>
        <Body size={400} textAlign="center">
          {bodyText}
        </Body>
      </Box>
      <Box alignSelf="center" justifyContent="space-around" width="100%">
        <Button height="44px" onClick={onPressResetYes} width="110px">
          {t('yes')}
        </Button>
        <Button
          fill="outline"
          height="44px"
          onClick={onPressResetNo}
          width="110px"
        >
          {t('no')}
        </Button>
      </Box>
    </SlideSmartMenu>
  );
};

export { ResetCard };
